export const ArrowLeft = ({
    width = 6,
    height = 10,
    strokeColor = "#D0D5DD",
  }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 6 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 9L1 5L5 1"
          stroke={strokeColor}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };